import React, { Component } from "react";
import {
  Typography,
  Grid,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Chip,
} from "@material-ui/core";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Button, FormControl, Card } from "react-bootstrap";
import { GetData, PostData, DeleteData, PutData } from "../../api/service";
import Snack from "../Snackbar/Snack";
import FileUpload from "../AddNew/FileUpload";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const PHOTO_UPLOAD_TYPE = "NEWSLETTER_PHOTO";

const EMPTY_FORM = {
  id: "",
  edit: false,
  title: "",
  issue: "",
  date: "",
  description: "",
  featured_photo: [],
};

class NewsletterManager extends Component {
  state = {
    ...EMPTY_FORM,
    data: [],
    isDataLoaded: false,
    message: "",
    open: false,
    loadFile: true,
  };

  componentDidMount() {
    this.__loadList();
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  __loadList = () => {
    this.setState({ isDataLoaded: false });
    GetData(`/getnewsletters`)
      .then((resp) => {
        this.setState({
          data: Array.isArray(resp) ? resp : [],
          isDataLoaded: true,
        });
      })
      .catch(() => {
        this.setState({ data: [], isDataLoaded: true });
      });
  };

  onSubmit = (e) => {
    e.preventDefault();

    const d = {
      id: this.state.id,
      title: this.state.title,
      issue: this.state.issue,
      date: this.state.date,
      posted_as: "NSS Unit, Dispur College",
      description: this.state.description,
      featured_photo: this.state.featured_photo,
    };

    if (this.state.edit) {
      PutData(`/${this.props.apikey}/${this.state.id}/editnewsletter`, d).then(
        (resp) => {
          this.setState({ message: resp, open: true }, () => this.__loadList());
          this.cancelEdit();
        }
      );
    } else {
      PostData(`/${this.props.apikey}/createnewsletter`, d).then((resp) => {
        this.setState({ message: resp, open: true }, () => this.__loadList());
        this.cancelEdit();
      });
    }
  };

  onDeleteClick = (el) => {
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure you want to delete this newsletter?",
      buttons: [
        { label: "Yes", onClick: this.onDeleteConfirm.bind(this, el.id) },
        { label: "No" },
      ],
    });
  };

  onDeleteConfirm = (id) => {
    DeleteData(`/${this.props.apikey}/${id}/deletenewsletter`).then((resp) => {
      this.setState({ message: resp, open: true }, () => this.__loadList());
    });
  };

  // backend returns date as dd-mm-yyyy; the <input type=date> needs yyyy-mm-dd
  __toInputDate = (d) => {
    if (!d || typeof d !== "string") return "";
    const parts = d.split("-");
    if (parts.length === 3 && parts[0].length === 2) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return d;
  };

  onEditClick = (el) => {
    this.setState(
      {
        id: el.id,
        title: el.title || "",
        issue: el.issue || "",
        date: this.__toInputDate(el.date),
        description: el.description || "",
        featured_photo: Array.isArray(el.featured_photo)
          ? el.featured_photo
          : [],
        edit: true,
        loadFile: false,
      },
      () => this.setState({ loadFile: true })
    );
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  cancelEdit = () => {
    this.setState({ ...EMPTY_FORM, loadFile: false }, () =>
      this.setState({ loadFile: true })
    );
  };

  render() {
    return (
      <div>
        {this.state.open ? (
          <Snack
            open={this.state.open}
            message={this.state.message}
            handleClose={() => this.setState({ open: false, message: "" })}
          />
        ) : null}

        <form onSubmit={this.onSubmit}>
          <Typography variant="h6" gutterBottom>
            {this.props.title || "Newsletters"}
          </Typography>
          <Typography variant="subtitle2" gutterBottom>
            Newsletters are displayed and read directly on the website (title,
            date, content and images).
          </Typography>

          <Card>
            <Card.Body>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <label>Title *</label>
                  <FormControl
                    as="input"
                    name="title"
                    required
                    onChange={this.onChange}
                    value={this.state.title}
                    placeholder="Newsletter title"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3} lg={3}>
                  <label>Issue / Volume</label>
                  <FormControl
                    as="input"
                    name="issue"
                    onChange={this.onChange}
                    value={this.state.issue}
                    placeholder="e.g. Vol. 1, Issue 1"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3} lg={3}>
                  <label>Date *</label>
                  <FormControl
                    as="input"
                    type="date"
                    name="date"
                    required
                    onChange={this.onChange}
                    value={this.state.date}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <label>Content</label>
                  <ReactQuill
                    placeholder="Write the newsletter content here"
                    value={this.state.description}
                    onChange={this.handleChange.bind(this, "description")}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <label>Photo(s) / Images (shown inline)</label>
                  {this.state.loadFile ? (
                    <FileUpload
                      dp={this.state.featured_photo}
                      type={PHOTO_UPLOAD_TYPE}
                      setDp={this.handleChange.bind(this, "featured_photo")}
                    />
                  ) : null}
                </Grid>
              </Grid>

              {this.state.edit ? (
                <div align="right">
                  <Button size="sm" variant="danger" type="submit">
                    Update
                  </Button>
                  &nbsp;
                  <Button
                    size="sm"
                    variant="secondary"
                    type="button"
                    onClick={this.cancelEdit}
                  >
                    Cancel
                  </Button>
                </div>
              ) : (
                <div align="right">
                  <Button size="sm" variant="info" type="submit">
                    Submit
                  </Button>
                </div>
              )}
            </Card.Body>
          </Card>

          <br />

          <Card>
            <Card.Body>
              <Typography variant="subtitle1" gutterBottom>
                Newsletters
              </Typography>

              {this.state.isDataLoaded ? (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell width="35%">Title</TableCell>
                      <TableCell>Issue</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell>Images</TableCell>
                      <TableCell>Edit</TableCell>
                      <TableCell>Delete</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Array.isArray(this.state.data) &&
                      this.state.data.map((el, index) => (
                        <TableRow key={el.id}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{el.title}</TableCell>
                          <TableCell>{el.issue}</TableCell>
                          <TableCell>{el.date}</TableCell>
                          <TableCell>
                            {Array.isArray(el.featured_photo) &&
                              el.featured_photo.map((el1, index1) => (
                                <Chip key={index1} label={el1.path} />
                              ))}
                          </TableCell>
                          <TableCell>
                            <Edit onClick={this.onEditClick.bind(this, el)} />
                          </TableCell>
                          <TableCell>
                            <Delete
                              onClick={this.onDeleteClick.bind(this, el)}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              ) : (
                <Typography>Loading . . .</Typography>
              )}
            </Card.Body>
          </Card>
        </form>
      </div>
    );
  }
}

export default NewsletterManager;
